module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-green-96fc960b77567ad832b8aec1882065b3.svg";